import React from 'react';
import ImageUploader from 'react-images-upload';


export default function FileUploader(param) {

    function onDrop(picture){
        param.callbackImage(picture);
    }


    return (
        <div>
            
            <ImageUploader
                withIcon={false}
                buttonText='이미지를 선택하세요.'
                imgExtension={['.jpg', '.gif', '.png', '.jpeg']}
                maxFileSize={5242880}
                withPreview={true}
                withLabel={false}
                fileSizeError='file size is too big'
                fileTypeError='is not supported file extension'
                label={param.imageName}
                singleImage={false}
                onChange={onDrop}
            />
        </div>
    );
}
 